module.exports = __webpack_public_path__ + "static/media/201.81b8e171.jpg";